/** @jsx jsx */
import React, { useState } from 'react'
import { jsx, Box, Input, Button, Alert } from 'theme-ui';
import update from 'immutability-helper'
import styles from './voucherForm.styles'
import StreamAMG from '../../api/streamAmg'
import { getIdToken } from '../../utils/auth'
import { navigate } from 'gatsby'

const VoucherForm = () => {

  const [state, setState] = useState({
    voucher: ''
  })
  const [error, setError] = useState()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false)
    const idToken = await getIdToken()
    const streamAMG = new StreamAMG({
      jwtToken: idToken ? idToken : null,
      language: 'en'
    })
    streamAMG.isVoucherCodeValid({code: state.voucher}, (response) => {
      if (!response.IsValid) {
        const error = response.ModelErrors?.code
        setError(error ? error : 'Invalid code')
      } else {
        navigate(response.RedirectUrl)
      }
    })
  }

  const handleChange = (e) => {
    setState(update(state, {
      [e.target.name]: {
        $set: e.target.value
      }
    }))
  }

  return (
    <React.Fragment>
      {error &&
        <Alert variant='error' mb={2}>{error}</Alert>
      }
      <Box
        as="form"
        onSubmit={handleSubmit}
        sx={styles.form}
      >
        <Input
          onChange={handleChange}
          name="voucher"
          type="text"
          sx={styles.input}
          value={state.voucher}
          placeholder='Got a voucher?'
        />
        <Button
          type="submit"
          variant="primary"
          sx={styles.button}
        >
          Submit
        </Button>
      </Box>
    </React.Fragment>
  )
}

export default VoucherForm
